// extracted by mini-css-extract-plugin
export default {"heading":"LandscapeIndicatorExternalResourcesTemplate_heading__1fEaH"};